export const SIGN_IN="/signin";
export const SLUG="/:slug";

export const VERIFY_EMAIL="/verify-email";
export const RESET_PASSWORD="/reset-password" ;
export const OTP_VERIFICATION="/email-verification";
export const SIGN_UP="/signup";
export const  INVITE="/invite";
export const BUY="/buy";
export const BUY_DETAILS="/buydetails";

export const PROFILE="/profile";
export const UNIRAMP="/uniramp";

export const  WITHDRAW_HISTORY="/withdraw-history";
export const BUY_SELL_HISTORY="/buy-sell-history";

export const KYC="/kyc";
export const SELL_CRYPTO="/sell-crypto";
export const SELL_ORDER="/sell-order";
export const PERSONAL_DETAILS="/personal-details";
export const SELL_KYC="/sell-kyc";
export const WALLET_CONNECT="/wallet-connect";
export const HISTORY="/history";
export const SETTINGS="/settings";
export const PORTFOLIO="/portfolio";
export const GRAPH="/graph/:symbol";
export const TERMS_CONDITIONS ="terms-conditions";
export const PRIVACY_POLICY ="privacy-policy";
export const BLOGS="/blogs";
export const VIEW_BLOGS="/view-blog/:slug";
export const FAVOURITES="/favourites";


